import { getFieldDisplayValue } from '../../../utils/fieldDisplayValue';
import { getSelectedField } from '../getSelectedField';
export function getDateRangeBucketFilterPayload(bucket, aggregation) {
    const { from, to } = bucket;
    const primaryField = getSelectedField(aggregation);
    const formattedFrom = getFieldDisplayValue(primaryField, from);
    const formattedTo = getFieldDisplayValue(primaryField, to);
    return {
        id: `${formattedFrom} - ${formattedTo}`,
        field: primaryField,
        filter: { [primaryField]: { gte: from, lte: to } },
    };
}
